import {
  RouteAndTeamContext,
  RouteAndTeamInfo,
} from "@/components/context-providers/RouteAndTeamInfoProvider";
import { RouteInfo, RouteInfoContext } from "@/components/context-providers/RouteInfoProvider";
import { useContext } from "react";

/** Returns all the variables we might extract from the url */
export function useRouteInfo(): RouteInfo {
  const contextValue = useContext(RouteInfoContext);
  if (contextValue == null) {
    throw new Error("useRouteInfo must be used within a RouteInfoProvider");
  }
  return contextValue;
}

/** Loads the team and grabs the relevant info out of it based on our location */
export function useRouteAndTeamInfo(): RouteAndTeamInfo {
  const contextValue = useContext(RouteAndTeamContext);
  if (contextValue == null) {
    throw new Error("useRouteAndTeamInfo must be used within a RouteAndTeamInfoProvider");
  }
  return contextValue;
}
